/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGoCampaign_OfficeGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Office Group API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Thursday, July 11, 2019 - 02:26:10 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/11/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GoCampaign_OfficeGroups = {
    all: (countryid, stateid, countyid, cityid) => requests.get(`/OfficeGroups?countryid=${countryid}&stateid=${stateid}&countyid=${countyid}&cityid=${cityid}`),
    get: officegroupid => requests.get(`/OfficeGroup/${officegroupid}`),
    create: officegroup => requests.post(`/OfficeGroups`, officegroup),
    update: (officegroupid, officegroup) => requests.put(`/OfficeGroup/${officegroupid}`, officegroup),
    delete: officegroupid => requests.del(`/OfficeGroup/${officegroupid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentGoCampaign_OfficeGroups.js